// Should the "turn your phone" screen cover the game? The game is a fixed 16:9 canvas, so on an
// upright phone it shrinks to a strip (390 px wide → a 219 px tall game with ~5 px text). Only
// touch devices are asked; a narrow desktop window is the player's own choice. An upright tablet
// (≥ 600 px wide) still gets a readable canvas, so it plays as it is.
export const MIN_UPRIGHT_WIDTH = 600;

export function needsRotate({ touch, width, height }) {
  return Boolean(touch) && height > width && width < MIN_UPRIGHT_WIDTH;
}
